<div
	class="flex flex-col min-w-0 overflow-hidden inset-0 absolute m-auto h-full">
	<div class="absolute w-full h-full" #map></div>
	<app-map-search-bar>
		<div #autocompleteContainer></div>
	</app-map-search-bar>
</div>

<!-- <div
	class="absolute left-5 bottom-5 bg-default border darker-border p-2 rounded-2xl">
	<app-locations-filter-searchable
		[filterTitle]="'vehicles|filter|locations'"
		(onFilterSelected)="onFilterLocationsChanged($event)" />
</div> -->

<ng-template #markerTemplate let-id="id" let-displayValue="displayValue">
	<div
		class="rounded-full bg-white dark:bg-black p-2 flex items-center shadow-long gap-2">
		<mat-icon class="icon-size-4" svgIcon="directions_car"></mat-icon>
		<app-vehicle-link-pill [id]="id" [displayValue]="displayValue" />
	</div>
</ng-template>
